export default (
  state = {
    isLoading: false,
    partners: [],
    calculator: { supplierId: null, points: null, miles: null },
    configuration: {},
    sendTwoFactorAuthorization: {
      enable: false,
      errorToken: false,
      secondFactorAuthConfirmated: false
    },
    errorRedemption: {}
  },
  action
) => {
  switch (action.type) {
    case 'FETCH_MILEAGE_PARTNERS':
      return {
        ...state,
        isLoading: true,
        partners: []
      }
    case 'FETCH_MILEAGE_PARTNERS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        partners: action.payload && action.payload.data
      }
    case 'FETCH_MILEAGE_PARTNERS_FAIL':
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case 'REDEMPTION_DISABLE_BUTTON':
      return {
        ...state,
        disableRedemption: action.value
      }
    case 'FETCH_POINTS_TO_MILES':
      return {
        ...state,
        disableRedemption: true,
        isLoading: true,
        calculator: { points: '', miles: '' }
      }
    case 'FETCH_POINTS_TO_MILES_SUCCESS':
      return {
        ...state,
        isLoading: false,
        disableRedemption: false,
        calculator: action.payload.data
      }
    case 'FETCH_POINTS_TO_MILES_FAIL':
      return {
        ...state,
        isLoading: false,
        error: action.error
      }
    case 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN':
      return {
        ...state,
        isLoading: false,
        enableConfiguration: false
      }
    case 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN_SUCCESS':
      const { configuration, partners } = state

      const supplierId = action.meta.previousAction.supplierId

      configuration[supplierId] = [...action.payload.data]

      const fidelityLabelConfig = vendorId => {
        const model = configuration[vendorId]

        if (model) {
          var filter = model.filter(x => x.key === 'LoyaltyNumberLabel')

          if (filter.length > 0) {
            return filter[0].value
          }
        } else {
          return ''
        }
      }

      return {
        ...state,
        isLoading: false,
        enableConfiguration: true,
        configuration: { ...configuration },
        partners:
        (partners && partners.map(p => ({
          ...p,
          fidelityLabel: fidelityLabelConfig(p.vendorId)
        }))) || []
      }
    case 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN_FAIL':
      return {
        ...state,
        isLoading: false,
        enableConfiguration: false,
        error: action.error
      }

    case 'CLEAR_CALCULATOR':
      return {
        ...state,
        calculator: { supplierId: null, points: '', miles: '' },
        errorRedemption: null
      }

    case 'REDEMPTION_MILEAGE_CLOSE_ERROR':
      return {
        ...state,
        errorRedemption: null
      }
    case 'REDEMPTION_MILEAGE_ERROR_BALANCE':
      return {
        ...state,
        errorRedemption: { title: '', description: 'Seu saldo é insuficiente.' },
        isLoading: false
      }

    case 'REDEMPTION_MILEAGE_MINIMUN_BALANCE':
      return {
        ...state,
        errorRedemption: { title: '', description: `Verifique se o seu saldo é maior que ${action.MinimunBalance} pontos ou tente novamente em alguns minutos` },
        isLoading: false
      }
    case 'REDEMPTION_MILEAGE_MINIMUN':
      return {
        ...state,
        errorRedemption: { title: '', description: `O Valor minimo de resgate é ${action.MinimumRedemption} pontos` },
        isLoading: false
      }
    case 'REDEMPTION_MILEAGE_ERROR_CPF':
      return {
        ...state,
        errorRedemption: { title: '', description: 'Digite um CPF válido.' },
        isLoading: false
      }

    case 'REDEMPTION_MILEAGE':
      return { ...state, isLoading: true, sendRedemptionMileage: true }
    case 'REDEMPTION_MILEAGE_SUCCESS':
      return {
        ...state,
        isLoading: false,
        sendRedemptionMileage: false,
        loadingResendToken: false,
        sendTwoFactorAuthorization: undefined
      }
    case 'REDEMPTION_MILEAGE_FAIL':
      return {
        ...state,
        isLoading: false,
        errorRedemption: { title: '', description: `Tente novamente em alguns minutos.` },
        sendRedemptionMileage: false,
        loadingResendToken: false,
        sendTwoFactorAuthorization: undefined
      }
    case 'AUTHORIZE_RESEND_FAIL':
      return {
        ...state,
        sendTwoFactorAuthorization: {
          ...state.sendTwoFactorAuthorization,
          enable: false,
          errorToken: false
        }
      }

    case 'MILEAGE_WITH_TOKEN':
      return {
        ...state,
        isLoading: true,
        isCreatingPurchase: true,
        loadingResendToken: true,
        sendTwoFactorAuthorization: {
          enable: !action.lastTry,
          orderId: action.orderId,
          orderMileageId: action.orderMileageId,
          errorToken: false,
          secondFactorAuthConfirmated: true,
          phone: state.sendTwoFactorAuthorization.phone
        }
      }
    case 'TOKEN_INVALID_MILEAGE':
      return {
        ...state,
        isLoading: false,
        isCreatingPurchase: false,
        loadingResendToken: false,
        errorRedemption: action.lastTry ? { title: '', description: 'Tentativas de verificação de token excedidas!' } : null,
        sendTwoFactorAuthorization: {
          enable: !action.lastTry,
          orderId: action.orderId,
          orderMileageId: action.orderMileageId,
          errorToken: true,
          secondFactorAuthConfirmated: true,
          phone: state.sendTwoFactorAuthorization.phone
        }
      }
    case 'AUTHORIZATION_REQUIRED_MILEAGE':
      return {
        ...state,
        isLoading: false,
        sendTwoFactorAuthorization: {
          enable: true,
          orderId: action.orderId,
          orderMileageId: action.orderMileageId,
          errorToken: false,
          secondFactorAuthConfirmated: true,
          phone: action.phone
        }
      }

    case 'ONBOARDING_REQUIRED_MILEAGE':
      return {
        ...state,
        isLoading: false,
        sendTwoFactorAuthorization: {
          enable: true,
          secondFactorAuthConfirmated: false
        }
      }

    case 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/OPEN':
      return {
        ...state,
        isLoading: false,
        disabledSelectPartners: false
      }

    case 'CONFIGURATION_MILEAGE_PARTNERS_CAMPAIGN/CLOSE':
      return {
        ...state,
        isLoading: true,
        disabledSelectPartners: true
      }

    case 'CLOSE_MODAL_SHOW_ERROR':
      return {
        ...state,
        sendTwoFactorAuthorization: {
          enable: false
        },
        errorRedemption: action.error ? { title: '', description: action.error } : null
      }

    case 'DECLINED_BY_RULE_MILEAGE':
      return {
        ...state,
        isLoading: false,
        sendRedemptionMileage: false,
        errorRedemption: { title: action.title, description: action.description }
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/features/Services/Mileage/reducer.js